//bao migrate skip
import baoDialog from "./../../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../../services/bao-service";
class ChecklistHistoryDialog {
    Bao = Bao;
    BaoDialog: baoDialog;
    Sorting = ko.observable();
    SelectedModel = ko.observable<any>();
    Models = ko.observableArray<any>([]);
    ChecklistId = ko.observable();
    constructor(checklistId: string, dialog: baoDialog) {
        this.BaoDialog = dialog;
        $.extend(this, checklistId);
        this.ChecklistId(checklistId);
        this.GetHistory();
    }
    GetHistory() {
        Bao.post("Checklist/GetChecklistHistory", JSON.stringify({
            checklistId: this.ChecklistId()
        }), (result) => {
            this.Models(result.Models);
        });
    }
    Download(id: any) {
        if (id != null) {
            window.open(Bao.Content("Checklist/DownloadHistory/" + id), '_blank');
        }
    }
    loaded() {
    }
}
export default ChecklistHistoryDialog;